import { useEffect, useState, useRef } from 'react';
import {useInterval, convertTzDate, utcToLocalDate, showToast} from '../common/app_common.js';
import {getApiAlertStatus, getApiAlertStatusCount, delApiAlertStatusFingerprint, delApiAlertResolved, delApiAlertStatus} from '../common/fetch_api/alert.js';
import {Title, PageNation, GotoMonitoring} from '../common/component_common.js';
import {DecideWindow} from '../common/modal_common.js';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import '.././common/css/alert_status.css';
import { BsFillExclamationSquareFill, BsFillSendCheckFill,
        BsFillSendExclamationFill, BsFillSendXFill, BsFillRocketTakeoffFill,  BsCheckCircleFill, BsChevronExpand
        } from "react-icons/bs";

const PAGE_PER = 19;

const PageAlertStatus = () =>
{
    const [filter, setFilter] = useState('');
    const [selectedCount, setSelectedCount] = useState(0);
    const [runRemove, setRunRemove] = useState(false);

    const removeUpdate = () => {
        setRunRemove(!runRemove);
    };

    const updateSelectedCount = () => {
        const checkBox = Array.from(document.getElementsByClassName('form-check-input'));
        const temp = [...checkBox].filter( (item) => {return item.id !== 'checkAll'});
        const checkTrue = [...temp].filter( (item) => {return item.checked === true }).length;
        setSelectedCount(checkTrue);
    };

    return (
        <>
            <div className="d-flex flex-wrap">
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <Title title='Alert'></Title>
                </div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <div className="d-flex justify-content-end">
                        <AlertFilter setFilter={setFilter} removeUpdate={removeUpdate} selectedCount={selectedCount}/>
                    </div>
                </div>
            </div>
            <AlertTable filter={filter} runRemove={runRemove} updateSelectedCount={updateSelectedCount}/>
        </>
    )
}

export default PageAlertStatus;

const AlertFilter = ({setFilter, removeUpdate, selectedCount}) =>
{
    const [modalRemove, setModalRemove] = useState(false);
    const closeModalRemove = () => setModalRemove(false);
    const [decideBtn, setDecideBtn] = useState('OK');
    const [decideBody, setDecideBody] = useState(null);

    const [severity, setSeverity] = useState('');

    const onChangeSeverity = (e) =>
    {
        setSeverity(e.target.value);
        setFilter(e.target.value);
    }

    const onClickRemoveAlert = (result) =>
    {
        if(!result) return;

        if(decideBtn === 'Remove Alert')
        {
            let tbody = document.getElementById('alertStatusTbody').childNodes;
            let checkedEdge = [];
        
            tbody.forEach(function(tr)
            {
                if( (tr.firstChild.firstChild).checked === true )
                {
                    checkedEdge.push(tr.id);
                }
            });

            if(checkedEdge.length)
            {
                let arr = [];
                for(let item of checkedEdge)
                {
                    arr.push(delApiAlertStatusFingerprint(item));
                }

                Promise.all( arr )
                .then( data => {
                    removeUpdate();
                });
            }
        }
        else if(decideBtn === 'Clear Resolved')
        {
            delApiAlertResolved()
            .then( data => {
                removeUpdate();
            });
        }
        else if(decideBtn === 'Clear Alert')
        {
            delApiAlertStatus()
            .then( data => {
                removeUpdate();
            });
        }
    }

    const showModalRemoveAlert = () =>
    {
        setDecideBtn('Remove Alert');
        setDecideBody(
            <div className='text-center'>
                <p>Would you like to remove {selectedCount} selected alert(s)?</p>
            </div>
        );
        
        setModalRemove(true);
    }

    const showModalClearResolved = () =>
    {
        setDecideBtn('Clear Resolved');
        setDecideBody(
            <div className='text-center'>
                <p>Would you like to clear all resolved alerts?</p>
            </div>
        );
        
        setModalRemove(true);
    }

    const showModalClearAlert = () =>
    {
        setDecideBtn('Clear Alert');
        setDecideBody(
            <div className='text-center'>
                <p>Would you like to clear all alerts?</p>
            </div>
        );
        
        setModalRemove(true);
    }

    return (
        <>
            <div className="d-flex justify-content-between">
                <div className="d-flex">
                    <span className="space-text">Filter</span>
                    <select className="form-select form-select-sm" onChange={onChangeSeverity} value={severity}>
                        <option value=''>All</option>
                        <option value='info'>Info</option>
                        <option value='warning'>Warning</option>
                        <option value='critical'>Critical</option>
                        <option value='firing'>Firing</option>
                        <option value='resolved'>Resolved</option>
                    </select>
                </div>
                <div className="d-flex ms-5">
                    <button className="btn btn-primary btn-sm me-2" 
                        onClick={showModalRemoveAlert}
                        disabled={selectedCount === 0}
                    >
                        Remove Alert {selectedCount > 0 && `(${selectedCount})`}
                    </button>
                    <button className="btn btn-primary btn-sm me-2" onClick={showModalClearResolved}>Clear Resolved</button>
                    <button className="btn btn-primary btn-sm me-2" onClick={showModalClearAlert}>Clear Alert</button>
                </div>
            </div>
            {modalRemove&&<DecideWindow result={onClickRemoveAlert} show={modalRemove} handleClose={closeModalRemove} body={decideBody} okButtonTxt={decideBtn}></DecideWindow>}
        </>
    )
}

const AlertTable = ({filter, runRemove, updateSelectedCount}) =>
{
    const [update, setUpdate] = useState(false);
    const [tableSpinner, setTableSpinner] = useState(false);

    const [pageSelCount, setPageSelCount] = useState(1);
    const [curPageState, setCurPageState] = useState(1);
    const curPageRef = useRef(0);

    const sortInfo = useRef({title:'', order:''});

    const [tbody, setTbody] = useState(null);

    const getAlertStatus = () =>
    {
        curPageRef.current.value = curPageState;

        Promise.resolve( getApiAlertStatusCount(filter) )
        .then( countData =>
        {
            if(countData.hasOwnProperty('count'))
            {
                setPageSelCount(Math.max(countData.count, 1));

                Promise.resolve( getApiAlertStatus(PAGE_PER, curPageState, filter, sortInfo.current.title, sortInfo.current.order) )
                .then( data => 
                {
                    let html = [];
                    for( let item of data)
                    {
                        let severity = '';
                        let edgeSeverity = '';
                        if(item.labels.severity === 'info')
                        {
                            severity = <BsFillExclamationSquareFill className="text-good me-1" />;
                            edgeSeverity = 'bg-good';
                        }
                        else if(item.labels.severity === 'warning')
                        {
                            severity = <BsFillExclamationSquareFill className="text-warning me-1" />;
                            edgeSeverity = 'bg-warning';
                        }
                        else if(item.labels.severity === 'critical')
                        {
                            severity = <BsFillExclamationSquareFill className="text-critical me-1" />;
                            edgeSeverity = 'bg-critical';
                        }
    
                        let edgeIconName = '';
                        if(item.labels.exported_job === 'm-agent')
                        {
                            edgeIconName = 'M';
                        }
                        else if(item.labels.exported_job === 's-agent')
                        {
                            edgeIconName = 'S';
                        }
                        else if(item.labels.exported_job === 'r-agent')
                        {
                            edgeIconName = 'R';
                        }
                        else if(item.labels.exported_job === 'rm')
                        {
                            edgeIconName = 'T';
                        }
    
                        let sendStatus = '';
                        if(item.sendStatus === 'ok')
                        {
                            sendStatus = <BsFillSendCheckFill className="text-good" />;
                        }
                        else if(item.sendStatus === 'ready')
                        {
                            sendStatus = <BsFillSendExclamationFill className="text-waring" />;
                        }
                        else
                        {
                            sendStatus = <BsFillSendXFill className="text-critical" />;
                        }
    
                        let status = '';
                        if(item.status === 'firing')
                        {
                            status = <BsFillRocketTakeoffFill className="text-info" />;
                        }
                        else if(item.status === 'resolved')
                        {
                            status = <BsCheckCircleFill className="text-good" />;
                        }
        
                        const summaryText = `${item.labels.summary}`;
                        const messageText = item.labels.message;
                        
                        html.push(
                            <tr key={item.fingerprint} id={item.fingerprint} onClick={ () => {
                                let input = document.getElementById(item.fingerprint).childNodes[0].firstChild;
                                input.checked = !input.checked;
                                checkOne();
                            }}>
                                <td><input className="form-check-input" type="checkbox" onClick={(e) => {
                                        e.target.checked = !e.target.checked;
                                        checkOne();
                                }}/></td>
                                <td>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id={`tooltip-summary-${item.fingerprint}`}>
                                                {summaryText}
                                            </Tooltip>
                                        }
                                    >
                                        <span style={{cursor: 'pointer'}}>
                                            {severity}{summaryText}
                                        </span>
                                    </OverlayTrigger>
                                </td>
                                <td>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id={`tooltip-message-${item.fingerprint}`}>
                                                {messageText}
                                            </Tooltip>
                                        }
                                    >
                                        <span style={{cursor: 'pointer'}}>
                                            {messageText}
                                        </span>
                                    </OverlayTrigger>
                                </td>
                                <td><div className={`edge-box ${edgeSeverity} me-2`}>{edgeIconName}</div><span>{`${item.labels.edgeName}`}</span></td>
                                <td>{item.labels.site}</td>
                                <td>{sendStatus}</td>
                                <td>{utcToLocalDate(convertTzDate(item.date))}</td>
                                <td>{status}</td>
                                <td>
                                    <GotoMonitoring siteName={item.labels.site} edgeId={item.labels.id} type={item.labels.exported_job}/>
                                </td>
                            </tr>
                        );
                    }
                    
                    setTbody(html);
                });
            }
            else
            {
                setTimeout(() => {setTableSpinner(false);}, 700);
                setTbody(null);
            }
        });
    };

    const checkOne = () => {
        const checkBox = Array.from(document.getElementsByClassName('form-check-input'));
        const checkAll = [...checkBox].filter( (item) => {return item.id === 'checkAll' })[0];
        const temp = [...checkBox].filter( (item) => {return item.id !== 'checkAll'});
        const checkTrue = [...temp].filter( (item) => {return item.checked === true }).length;
        const checkTotal = temp.length;

        if( checkAll.checked === true && checkTrue < checkTotal)
        {
            checkAll.checked = false;
        }
        else if( checkAll.checked === false && checkTrue >= checkTotal)
        {
            checkAll.checked = true;
        }

        // 선택된 개수 업데이트
        if (updateSelectedCount) {
            updateSelectedCount();
        }
    }

    const checkAll = (e) => {
        const checkBox = Array.from(document.getElementsByClassName('form-check-input'));

        let checked = false;
        if( e.target.checked === true )
        {
            checked = true;
        }

        checkBox.forEach(function(item) {
            item.checked = checked;
        });

        // 선택된 개수 업데이트
        if (updateSelectedCount) {
            updateSelectedCount();
        }
    }

    const checkClear = () => {
        const checkBox = Array.from(document.getElementsByClassName('form-check-input'));

        checkBox.forEach(function(item) {
            item.checked = false;
        });

        // 선택된 개수 업데이트
        if (updateSelectedCount) {
            updateSelectedCount();
        }
    }

    function toggleSort(title)
    {
        checkClear();

        let curTitle = sortInfo.current.title;
        let curOrder = sortInfo.current.order;

        if( curTitle === title )
        {
            if( curOrder === 'asc' )
            {
                curOrder = 'desc';
            }
            else
            {
                curOrder = 'asc';
            }
        }
        else
        {
            curTitle = title;
            curOrder = 'asc';
        }

        sortInfo.current = {title: curTitle, order: curOrder};

        setTableSpinner(true);
        getAlertStatus();
    }

    const runUpdate = () => {
        setUpdate(!update);
    };

    //처음 페이지로딩시 2번 useEffect 실행을 방지위해 다음과 같이
    const firstLoading = useRef(true);

    useEffect(() =>
    {
        if( !firstLoading.current )
        {
            // console.log('변화로딩')
            setTableSpinner(true);
            getAlertStatus();
            setCurPageState(1);
        }
    }, [filter]);

    useEffect(() =>
    {
        if( !firstLoading.current )
        {
            // console.log('remove, page 이동로딩')
            setTableSpinner(true);
            getAlertStatus();
            checkClear();
        }
    }, [runRemove, curPageState]);

    //페이지 첫 로딩, firstLoading 만 바꾸어줌. **순서가 중요함. 첫로딩 useEffect가 맨 마지막에 와야함.
    useEffect(() =>
    {
        // console.log('첫로딩')
        setTableSpinner(true);
        getAlertStatus();

        firstLoading.current = false;
    }, [update]);

    //table 변화후 spinner가 중지..
    const initSpinner = useRef(true);
    useEffect( () => {
        if(initSpinner.current)
        {
            initSpinner.current = false;
            return;
        }
        
        setTimeout(() => {setTableSpinner(false);}, 700);
    }, [tbody]);

    useInterval(() =>
    {
        runUpdate();
    }, 10000 );

    return (
        <>
        <div className="d-flex flex-column">
            <div className="section alert-status-table position-relative mt-2">
                {tableSpinner && <div className="table-spinner spinner-border text-default"></div>}
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th><input className="form-check-input" id='checkAll' type="checkbox" onClick={checkAll}/></th>
                            <th className="sorting" onClick={() => {toggleSort('alertname');}}>Summary<BsChevronExpand /></th>
                            <th className="sorting" onClick={() => {toggleSort('message');}}>Message<BsChevronExpand /></th>
                            <th>Edge</th>
                            <th>Site</th>
                            <th className="sorting" onClick={() => {toggleSort('send_status');}}>Send<BsChevronExpand /></th>
                            <th className="sorting" onClick={() => {toggleSort('date');}}>Created At<BsChevronExpand /></th>
                            <th className="sorting" onClick={() => {toggleSort('status');}}>Status<BsChevronExpand /></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody id='alertStatusTbody'>
                        {tbody}
                    </tbody>
                </table>
            </div>
            <PageNation
                curPageState={curPageState}
                setCurPageState={setCurPageState}
                selCount={pageSelCount}
                pagePer={PAGE_PER}
                ref={curPageRef}
            ></PageNation>
        </div>
        </>
    )
}